import { Bookmark, Calculator, Clock, Flag, Minus, Plus } from "lucide-react";

const MockTestSections =({setCloseReportPopUp,responseArray,currentQuestionObject,activeID,sectionsArr,showCalci,currentSection,sectionStatsAll,setOpenCalculator,mockTestCard1Object,setQuestionsArr,questionsArrDummy,
    setCurrentSection,setCurrentSectionIndex,setCurrentQuestionIndex,setCurrentQuestionObject,
    SetQuestionVisited,setLoadSections,handleQuestionClick
})=>{
      const getQuestionsFromOneSection = (questionsArrAll, secQuestionsIDArr) => { 
  let secQuestions = [];

  try {
    secQuestions = Array.isArray(secQuestionsIDArr)
      ? secQuestionsIDArr
      : JSON.parse(secQuestionsIDArr || '[]');
  } catch (e) {
    console.warn("Invalid JSON in secQuestions", e);
    return [];
  }

  // Map of all available questions by ID for fast lookup
  const questionMap = new Map();
  questionsArrAll?.forEach(q => questionMap.set(q?.ID, q));

  // Preserve the order from secQuestions
  return secQuestions
    .map(q => questionMap.get(q?.ID))
    .filter(Boolean); // remove undefined if any ID is not found
};
    const getTimerByActiveID = ( activeID) => {
  const question = responseArray.find(q => q.ID === activeID);
  return question ? question.timer : 0;
};
  const formatTimeQue = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return hours?[
    hours.toString().padStart(2, '0'),
    minutes.toString().padStart(2, '0'),
    seconds.toString().padStart(2, '0'),
  ].join(':'):[
   
    minutes.toString().padStart(2, '0'),
    seconds.toString().padStart(2, '0'),
  ].join(':');
};

    
  const formatTime = (seconds) => {
    const hrs = String(Math.floor(seconds / 3600)).padStart(2, '0');
    const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
    const secs = String(seconds % 60).padStart(2, '0');
    return `${hrs}:${mins}:${secs}`;
  };
    return(<>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",margin:"0px" ,gap:"10px",}}>
          <div className="quizSectionAll mockTestButtonFont " style={{marginBottom:"5px"}}
          // onClick={()=>{setQuestionsArr(questionsArrDummy);setCurrentSection("")}}
          
          > Section All 
            <div className="quizSectionAllInn" style={{zIndex:"999999999"}}>
              
              <div className="palletInfoBtn"> <div className="palletNotAttempdedButtonSmall" 
         style={{}} ><Clock size={20} color={"#222"}/>
         </div>
             <div className="palletInfoTitle mockTestTitleFont"> Time Spent: {sectionStatsAll?.timeSpent?formatTime(sectionStatsAll?.timeSpent):formatTime(0)}</div> 
        </div>
            <div className="palletInfoBtn"> <div className="palletNotAttempdedButtonSmall " 
         style={{background:"#ddd",color:"#333"}}
         >{sectionStatsAll?.notVisited}</div>
             <div className="palletInfoTitle mockTestSubTitleFont"> Not Visited</div> 
        </div><div className="palletInfoBtn">
            <div className="palletAttempdedButtonSmall" 
         style={{}}
         >{sectionStatsAll?.answered}</div>    <div className="palletInfoTitle mockTestSubTitleFont"> Answered</div> 
        </div><div className="palletInfoBtn">
           <div className="palletNotAttempdedButtonSmall" 
         style={{}}
         >{sectionStatsAll?.visited}</div>   <div className="palletInfoTitle mockTestSubTitleFont"> Not Answered</div> 
        </div>
        <div className="palletInfoBtn">
           <div className="palletNotAttempdedButtonSmall" 
         style={{}}
         ><div className="palletAttempdedButtonInnSmall"  style={{}}
         ></div>{ sectionStatsAll?.markedAndNotAnswered}</div>
           <div className="palletInfoTitle mockTestSubTitleFont"> Not Answered And Marked</div> 
        </div><div className="palletInfoBtn">
           <div className="palletAttempdedButtonSmall" 
         style={{}}
         ><div className="palletAttempdedButtonInnSmall"  style={{}}
         ></div>{ sectionStatsAll?.markedAndAnswered}</div>    <div className="palletInfoTitle mockTestSubTitleFont"> Answered And Marked</div> 
        </div>
          </div>
          </div>
          <div style={{display:"flex",justifyContent:"left",marginTop:"-15px"}}>
         <div onClick={()=>{}} className="" style={{cursor:"pointer",background:`${mockTestCard1Object?.bookmarkBtn?.bgColor?.color}`,
    border:` ${mockTestCard1Object?.bookmarkBtn?.border?.borderWidth?.value+mockTestCard1Object?.bookmarkBtn?.border?.borderWidth?.resolution} ${mockTestCard1Object?.bookmarkBtn?.border?.borderType}  ${mockTestCard1Object?.bookmarkBtn?.border?.borderColor?.color}`,
     borderTopLeftRadius:`${mockTestCard1Object?.bookmarkBtn?.borderRadius?.topLeft?.value}${mockTestCard1Object?.bookmarkBtn?.borderRadius?.topLeft?.resolution}`,
                  borderTopRightRadius:`${mockTestCard1Object?.bookmarkBtn?.borderRadius?.topRight?.value}${mockTestCard1Object?.bookmarkBtn?.borderRadius?.topRight?.resolution}`,
                  borderBottomLeftRadius:`${mockTestCard1Object?.bookmarkBtn?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.bookmarkBtn?.borderRadius?.bottomLeft?.resolution}`,
                  borderBottomRightRadius:`${mockTestCard1Object?.bookmarkBtn?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.bookmarkBtn?.borderRadius?.bottomRight?.resolution}`,
    width:"30px",height:"30px",padding:"3px",display:"flex",justifyContent:"center",alignItems:"center",margin:"5px",marginTop:"10px",}}>
            <Bookmark style={{position:"relative"}}   color={mockTestCard1Object?.bookmarkBtn?.iconColor?.color} size={20}/>
            </div>
        <div onClick={()=>{setCloseReportPopUp(true)}} className="" style={{cursor:"pointer",background:`${mockTestCard1Object?.flagBtn?.bgColor?.color}`,
    border:` ${mockTestCard1Object?.flagBtn?.border?.borderWidth?.value+mockTestCard1Object?.flagBtn?.border?.borderWidth?.resolution} ${mockTestCard1Object?.flagBtn?.border?.borderType}  ${mockTestCard1Object?.flagBtn?.border?.borderColor?.color}`,
     borderTopLeftRadius:`${mockTestCard1Object?.flagBtn?.borderRadius?.topLeft?.value}${mockTestCard1Object?.flagBtn?.borderRadius?.topLeft?.resolution}`,
                  borderTopRightRadius:`${mockTestCard1Object?.flagBtn?.borderRadius?.topRight?.value}${mockTestCard1Object?.flagBtn?.borderRadius?.topRight?.resolution}`,
                  borderBottomLeftRadius:`${mockTestCard1Object?.flagBtn?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.flagBtn?.borderRadius?.bottomLeft?.resolution}`,
                  borderBottomRightRadius:`${mockTestCard1Object?.flagBtn?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.flagBtn?.borderRadius?.bottomRight?.resolution}`,
    width:"30px",height:"30px",padding:"3px",display:"flex",justifyContent:"center",alignItems:"center",margin:"5px",marginTop:"10px",}}>
            <Flag style={{position:"relative"}}   color={mockTestCard1Object?.flagBtn?.iconColor?.color} size={20}/>
            </div>
    {showCalci=="true"?<div onClick={()=>{setOpenCalculator(true)}} className="" style={{cursor:"pointer",background:`${mockTestCard1Object?.calculatorBtn?.bgColor?.color}`,
    border:` ${mockTestCard1Object?.calculatorBtn?.border?.borderWidth?.value+mockTestCard1Object?.calculatorBtn?.border?.borderWidth?.resolution} ${mockTestCard1Object?.calculatorBtn?.border?.borderType}  ${mockTestCard1Object?.calculatorBtn?.border?.borderColor?.color}`,
     borderTopLeftRadius:`${mockTestCard1Object?.calculatorBtn?.borderRadius?.topLeft?.value}${mockTestCard1Object?.calculatorBtn?.borderRadius?.topLeft?.resolution}`,
                  borderTopRightRadius:`${mockTestCard1Object?.calculatorBtn?.borderRadius?.topRight?.value}${mockTestCard1Object?.calculatorBtn?.borderRadius?.topRight?.resolution}`,
                  borderBottomLeftRadius:`${mockTestCard1Object?.calculatorBtn?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.calculatorBtn?.borderRadius?.bottomLeft?.resolution}`,
                  borderBottomRightRadius:`${mockTestCard1Object?.calculatorBtn?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.calculatorBtn?.borderRadius?.bottomRight?.resolution}`,
    width:"30px",height:"30px",padding:"3px",display:"flex",justifyContent:"center",alignItems:"center",margin:"5px",marginTop:"10px",}}>
            <Calculator style={{position:"relative"}}   color={mockTestCard1Object?.calculatorBtn?.iconColor?.color} size={20}/>
    </div>:""}</div>
    
          </div>
    
           <div className="quizSectionGridClass" style={{alignItems:"center",margin:"0px" ,gap:"10px",}}>
         <div style={{display:"flex",justifyContent:"left",gap:"5px"}}> {sectionsArr?.map((item,index) =>(<div  key={item?.ID || index} 
            onClick={()=>{setQuestionsArr(getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions));setCurrentSection(item);
              setCurrentSectionIndex(index);  setCurrentQuestionIndex(0);
                setCurrentQuestionObject(getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions).length?getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions)[0]:[])
                 SetQuestionVisited(getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions).length?getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions)[0]:[],"visited");
                setLoadSections(false); setTimeout(()=>{ setLoadSections(true); },0);
                 handleQuestionClick(getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions).length?getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions)[0]?.ID:"");
                 }} >
            {index<2?<div className={`quizSectionAll `}
           style={{}}> <div className="ellipsisTitleQuiz mockTestButtonFont "  >  {item?.sectionName} </div>
            <div className="quizSectionAllInn" style={{zIndex:"999999999"}}>
           <div className="palletInfoTitle">  {item?.sectionName}</div>   
             <div className="palletInfoBtn"> <div className="palletNotAttempdedButtonSmall" 
         style={{}} ><Clock size={20} color={"#222"}/>
         </div>
             <div className="palletInfoTitle mockTestTitleFont"> Time Spent: {sectionsArr[index]?.sectionStats?.timeSpent?formatTime(sectionsArr[index]?.sectionStats?.timeSpent):formatTime(0)}</div> 
        </div> <div className="palletInfoBtn"> <div className="palletNotAttempdedButtonSmall" 
         style={{background:"#ddd",color:"#333"}}
         >{sectionsArr[index]?.sectionStats?.notVisited}</div>
             <div className="palletInfoTitle mockTestSubTitleFont"> Not Visited</div> 
        </div><div className="palletInfoBtn">
            <div className="palletAttempdedButtonSmall" 
         style={{}}
         >{sectionsArr[index]?.sectionStats?.answered}</div>    <div className="palletInfoTitle mockTestSubTitleFont"> Answered</div> 
        </div><div className="palletInfoBtn">
           <div className="palletNotAttempdedButtonSmall" 
         style={{}}
         >{sectionsArr[index]?.sectionStats?.visited}</div>   <div className="palletInfoTitle mockTestSubTitleFont"> Not Answered</div> 
        </div>
        <div className="palletInfoBtn">
           <div className="palletNotAttempdedButtonSmall" 
         style={{}}
         ><div className="palletAttempdedButtonInnSmall"  style={{}}
         ></div>{sectionsArr[index]?.sectionStats?.markedAndNotAnswered}</div>
           <div className="palletInfoTitle mockTestSubTitleFont"> Not Answered And Marked</div> 
        </div><div className="palletInfoBtn">
           <div className="palletAttempdedButtonSmall" 
         style={{}}
         ><div className="palletAttempdedButtonInnSmall"  style={{}}
         ></div>{sectionsArr[index]?.sectionStats?.markedAndAnswered}</div>    <div className="palletInfoTitle mockTestSubTitleFont"> Answered And Marked</div> 
        </div>
          </div>
          </div>:""}</div>))}
         
          {sectionsArr?.length>2?<div className="quizSectionAllMore mockTestButtonFont" > More Sections
            <div className="quizSectionAllInnMore" style={{margin:"0px" ,gap:"10px",}}>
        
             {sectionsArr?.map((item,index) =>(
              <div  key={item?.ID || index}  
              onClick={()=>{setQuestionsArr(getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions));setCurrentSection(item);
                 setCurrentSectionIndex(index);setCurrentQuestionIndex(0);
                   setCurrentQuestionObject(getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions).length?getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions)[0]:[])
                     SetQuestionVisited(getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions).length?getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions)[0]:[],"visited");
               
                   setLoadSections(false); setTimeout(()=>{ setLoadSections(true); },0);
                    handleQuestionClick(getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions).length?getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions)[0]?.ID:"");
              }} >
            {index>=2?  <div className= {`quizSectionMoreItem ${item?.ID===currentSection?.ID?"activeQuizSection":""} `} style={{}}> <div className="ellipsisTitleQuiz mockTestButtonFont" style={{width:" 150px",display:"flex",justifyContent:"center",alignItems:"center",}}>  {item?.sectionName} </div>
            <div className="quizSectionMoreItemInn" >
                <div className="palletInfoTitle mockTestTitleFont">  {item?.sectionName}</div>   
           <div className="palletInfoBtn"> <div className="palletNotAttempdedButtonSmall" 
         style={{}} ><Clock size={20} color={"#222"}/>
         </div>
             <div className="palletInfoTitle mockTestTitleFont"> Time Spent: {sectionsArr[index]?.sectionStats?.timeSpent?formatTime(sectionsArr[index]?.sectionStats?.timeSpent):formatTime(0)}</div> 
        </div> <div className="palletInfoBtn"> <div className="palletNotAttempdedButtonSmall" 
         style={{background:"#ddd",color:"#333"}}
         >{sectionsArr[index]?.sectionStats?.notVisited}</div>
             <div className="palletInfoTitle mockTestSubTitleFont mockTestSubTitleFont"> Not Visited</div> 
        </div><div className="palletInfoBtn">
            <div className="palletAttempdedButtonSmall" 
         style={{}}
         >{sectionsArr[index]?.sectionStats?.answered}</div>    <div className="palletInfoTitle mockTestSubTitleFont"> Answered</div> 
        </div><div className="palletInfoBtn">
           <div className="palletNotAttempdedButtonSmall" 
         style={{}}
         >{sectionsArr[index]?.sectionStats?.visited}</div>   <div className="palletInfoTitle mockTestSubTitleFont"> Not Answered</div> 
        </div>
        <div className="palletInfoBtn">
           <div className="palletNotAttempdedButtonSmall" 
         style={{}}
         ><div className="palletAttempdedButtonInnSmall"  style={{}}
         ></div>{sectionsArr[index]?.sectionStats?.markedAndNotAnswered}</div>
           <div className="palletInfoTitle mockTestSubTitleFont"> Not Answered And Marked</div> 
        </div><div className="palletInfoBtn">
           <div className="palletAttempdedButtonSmall" 
         style={{}}
         ><div className="palletAttempdedButtonInnSmall"  style={{}}
         ></div>{sectionsArr[index]?.sectionStats?.markedAndAnswered}</div>    <div className="palletInfoTitle mockTestSubTitleFont"> Answered And Marked</div> 
        </div>
          </div>
          </div>:""} </div>))}
    
        
          </div>
            
          </div>:""}
          </div>
           <div style={{display:"flex",justifyContent:"left",gap:"10px"}}>
          <div className="quizSectionAllMore mockTestTitleFont" style={{ width:"100px", margin:"0px" ,gap:"10px",background:`${mockTestCard1Object?.questionTimer?.bgColor?.color}`,
    border:` ${mockTestCard1Object?.questionTimer?.border?.borderWidth?.value+mockTestCard1Object?.questionTimer?.border?.borderWidth?.resolution} ${mockTestCard1Object?.questionTimer?.border?.borderType}  ${mockTestCard1Object?.questionTimer?.border?.borderColor?.color}`,
     borderTopLeftRadius:`${mockTestCard1Object?.questionTimer?.borderRadius?.topLeft?.value}${mockTestCard1Object?.questionTimer?.borderRadius?.topLeft?.resolution}`,
                  borderTopRightRadius:`${mockTestCard1Object?.questionTimer?.borderRadius?.topRight?.value}${mockTestCard1Object?.questionTimer?.borderRadius?.topRight?.resolution}`,
                  borderBottomLeftRadius:`${mockTestCard1Object?.questionTimer?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.questionTimer?.borderRadius?.bottomLeft?.resolution}`,
                  borderBottomRightRadius:`${mockTestCard1Object?.questionTimer?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.questionTimer?.borderRadius?.bottomRight?.resolution}`,
    }}> <Clock style={{position:"relative"}}   color={mockTestCard1Object?.questionTimer?.iconColor?.color} size={20}/> {formatTimeQue(getTimerByActiveID(activeID))}</div>
          
            <div className="" style={{margin:"0px" ,}}> 
              {currentQuestionObject?.enableDisplayMarks=="true"?<div style={{display:"flex",justifyContent:"space-between",gap:"10px",padding:"5px"}}>
     <div className="mockTestTagsFont" style={{display:"flex",borderRadius:"5px",justifyContent:"space-between",padding:"5px",background:`${mockTestCard1Object?.plusMarks?.bgColor?.color}`,
    border:` ${mockTestCard1Object?.plusMarks?.border?.borderWidth?.value+mockTestCard1Object?.plusMarks?.border?.borderWidth?.resolution} ${mockTestCard1Object?.plusMarks?.border?.borderType}  ${mockTestCard1Object?.plusMarks?.border?.borderColor?.color}`,
     borderTopLeftRadius:`${mockTestCard1Object?.plusMarks?.borderRadius?.topLeft?.value}${mockTestCard1Object?.plusMarks?.borderRadius?.topLeft?.resolution}`,
                  borderTopRightRadius:`${mockTestCard1Object?.plusMarks?.borderRadius?.topRight?.value}${mockTestCard1Object?.plusMarks?.borderRadius?.topRight?.resolution}`,
                  borderBottomLeftRadius:`${mockTestCard1Object?.plusMarks?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.plusMarks?.borderRadius?.bottomLeft?.resolution}`,
                  borderBottomRightRadius:`${mockTestCard1Object?.plusMarks?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.plusMarks?.borderRadius?.bottomRight?.resolution}`,
    }}>
     <Plus  style={{position:"relative"}}   color={mockTestCard1Object?.plusMarks?.iconColor?.color} size={20}/>
              {currentQuestionObject?.marks}
              </div> <div className="mockTestTagsFont" style={{display:"flex",borderRadius:"5px",justifyContent:"space-between",padding:"5px",background:`${mockTestCard1Object?.negativeMarks?.bgColor?.color}`,
    border:` ${mockTestCard1Object?.negativeMarks?.border?.borderWidth?.value+mockTestCard1Object?.negativeMarks?.border?.borderWidth?.resolution} ${mockTestCard1Object?.negativeMarks?.border?.borderType}  ${mockTestCard1Object?.negativeMarks?.border?.borderColor?.color}`,
     borderTopLeftRadius:`${mockTestCard1Object?.negativeMarks?.borderRadius?.topLeft?.value}${mockTestCard1Object?.negativeMarks?.borderRadius?.topLeft?.resolution}`,
                  borderTopRightRadius:`${mockTestCard1Object?.negativeMarks?.borderRadius?.topRight?.value}${mockTestCard1Object?.negativeMarks?.borderRadius?.topRight?.resolution}`,
                  borderBottomLeftRadius:`${mockTestCard1Object?.negativeMarks?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.negativeMarks?.borderRadius?.bottomLeft?.resolution}`,
                  borderBottomRightRadius:`${mockTestCard1Object?.negativeMarks?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.negativeMarks?.borderRadius?.bottomRight?.resolution}`,
    }}>
     <Minus style={{position:"relative"}}   color={mockTestCard1Object?.negativeMarks?.iconColor?.color} size={20}/>
                {currentQuestionObject?.negativeMarks}
              </div>   </div>:""}
                </div></div>
        
          </div></>)
}
export default MockTestSections;